<template>
    <div>
        <div class="questions-wrapper">
            <div v-for="(question, index) in surveyQuestions" :key="index" class="form-group question-box"
                 style="border: 1px solid #ddd; padding: 10px;">
                <Question
                    :type="question.type"
                    :is-required="question.is_required"
                    :text="question.text"
                    :sort-order="question.sort_order"
                    :question-id="question.id"
                    :survey-id="surveyId"
                    :is-survey-active="isActive"
                    :desktop-image-url="question.desktop_image_url"
                    :mobile-image-url="question.mobile_image_url"
                    @question-removed="loadQuestions"
                    @question-updated="loadQuestions"

                />
                <div style="margin-top: 16px"></div>
                <Answer
                    v-if="question.type !== 'open' && question.type !== 'number'"
                    v-for="(answer, answerIndex) in question.answers"
                    :text="answer.text"
                    :sort-order="answer.sort_order"
                    :question-id="question.id"
                    :survey-id="surveyId"
                    :is-survey-active="isActive"
                    :answer-id="answer.id"
                    @answer-removed="loadQuestions"
                    @answer-updated="loadQuestions"
                    :key="answerIndex"
                />

                <div v-if="question.type !== 'open' && question.type !== 'number'" class="col-md-12">
                    <CreateAnswer @add-answer="addAnswer" :question-id="question.id" :is-survey-active="isActive" />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-md-3">
                <label for="newQuestion" class="form-label">{{ _t('Question') }}</label>
                <input v-model="newQuestion.text" type="text" id="newQuestion" class="form-control"/>
            </div>
            <div class="form-group col-md-3">
                <label class="form-label">{{ _t('Question type') }}</label>

                <select v-model="newQuestion.type" class="form-control">
                    <option value="">{{ _t('Select...') }}</option>
                    <option value="open">{{ _t('open') }}</option>
                    <option value="number">{{ _t('number') }}</option>
                    <option value="single_answer">{{ _t('single_answer') }}</option>
                    <option value="multi_answer">{{ _t('multi_answer') }}</option>
                </select>
            </div>
            <div class="form-group col-md-3">
                <label class="form-label" for="sortOrder">{{ _t('Sort order') }}</label>

                <input v-model="newQuestion.sort_order" class="form-control" type="number" id="sortOrder">
            </div>
            <div class="form-group col-md-3">
                <label class="form-label" for="isRequiredCheckbox">{{ _t('Required answer') }}</label>

                <input v-model="newQuestion.is_required" class="checkbox" type="checkbox" id="isRequiredCheckbox">
            </div>
            <div class="col-md-6 mt-3">
                <label for="imageDesktop" class="form-label">Desktop image</label>
                <input class="form-control" type="file" id="imageDesktop"  @change="handleFileChange($event, 'desktop')" ref="fileInput">
                <img :src="newQuestion.desktop_image_preview" class="mt-3 img-fluid" v-if="newQuestion.desktop_image_preview">
            </div>
            <div class="col-md-6 mt-3">
                <label for="imageMobile" class="form-label">Mobile image</label>
                <input class="form-control" type="file" id="imageMobile"  @change="handleFileChange($event, 'mobile')" ref="fileInputMobile">
                <img :src="newQuestion.mobile_image_preview" class="mt-3 img-fluid" v-if="newQuestion.mobile_image_preview">
            </div>
        </div>

        <div class="row">
            <div class="form-group col-md-12">
                <button :disabled="isActive" @click="addQuestion" class="btn btn-primary mt-3">
                    <i class="fa fa-plus"/>
                    {{ _t('Add question') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>

import Swal from "sweetalert2";
import ShowQuestion from "./ShowQuestion";
import Question from "./Question";
import CreateAnswer from "./CreateAnswer";
import Answer from "./Answer";
import Url from "blueimp-load-image";

export default {
    components: {CreateAnswer, Question, ShowQuestion, Answer},
    props: {
        surveyId: {
            type: Number,
            required: true
        },
        routineOptions: {
            type: Object,
            required: true
        },
        storeQuestionsRoute: {
            type: String,
            required: true,
        },
        isActive: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            surveyQuestions: [],
            selectedFile: null,
            newQuestion: {
                text: "",
                type: "", // Default to open-ended
                is_required: true, // Default to not required
                sort_order: 0,
            },

        };
    },
    created() {
        this.loadQuestions();
    },
    methods: {

        loadQuestions() {
            axios.get(`/survey/${this.surveyId}/questions`)
                .then((res) => {
                    this.surveyQuestions = this.mapQuestions(res.data)
                })
                .catch((err) => {
                    Swal.fire({
                        text: err.response.data.message || 'Something went wrong',
                        icon: "error",
                        duration: '1000'
                    })
                })
                .finally(() => this.isLoading = false);
        },
        async addQuestion() {
            if (this.newQuestion.text.trim() === "") {
                Swal.fire(_t("Error"), _t("Question text cannot be empty."), "error");
                return;
            }

            if (!this.newQuestion.type) {
                Swal.fire(_t("Error"), _t("The field Question type is required."), "error");
                return;
            }

            const formData = new FormData();
            formData.append('text', this.newQuestion.text);
            formData.append('type', this.newQuestion.type);
            formData.append('sort_order', this.newQuestion.sort_order);
            formData.append('is_required', (this.newQuestion.is_required ? 1 : 0));
            if (this.newQuestion.desktop_image)
                formData.append('desktop_image', this.newQuestion.desktop_image);
            if (this.newQuestion.mobile_image)
                formData.append('mobile_image', this.newQuestion.mobile_image);


            axios.post(`/survey/${this.surveyId}/questions`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
                .then((res) => {
                    this.surveyQuestions = this.mapQuestions(res.data)
                    this.resetNewQuestion();
                    Swal.fire({
                        text: _t("Question added successfully!"),
                        icon: "success",
                        duration: '1000'
                    })
                })
                .catch((err) => {
                    console.log(err)
                    Swal.fire({
                        text: err.response.data.message || 'Something went wrong',
                        icon: "error",
                        duration: '1000'
                    })
                });
        },
        addAnswer(answerData) {
            const questionId = answerData.questionId;
            const answer = answerData.answer;

            if (answer.text.trim() === "") {
                Swal.fire(_t("Error"), _t("Answer text cannot be empty."), "error");
                return;
            }

            axios.post(`/survey/${this.surveyId}/question/${questionId}/answer`, answer)
                .then((res) => {
                    this.surveyQuestions = this.mapQuestions(res.data)
                    Swal.fire({
                        text: _t("Answer added successfully!"),
                        icon: "success",
                        duration: '1000'
                    })
                })
                .catch((err) => {
                    console.log(err)
                    Swal.fire({
                        text: err.response.data.message || 'Something went wrong',
                        icon: "error",
                        duration: '1000'
                    })
                });


        },

        resetNewQuestion() {
            this.newQuestion = {
                text: "",
                type: "",
                is_required: true,
                sort_order: 0
            };
        },

        submitForm() {
            const invalidQuestion = this.surveyQuestions.some(question => question.text.trim() === "" || question.answers.some(answer => answer.text.trim() === ""));

            if (invalidQuestion) {
                Swal.fire(_t("Error"), _t("Question and answer text cannot be empty."), "error");
                return;
            }

            const surveyData = {
                questions: this.surveyQuestions.map(question => {
                    return {
                        text: question.text,
                        type: question.type,
                        is_required: question.is_required,
                        answers: question.answers.map(answer => ({text: answer.text, sort_order: answer.sort_order})),
                        sort_order: question.sort_order
                    };
                })
            };

            const jsonData = JSON.stringify(surveyData);

            axios.post(this.storeQuestionsRoute, surveyData)
                .then((res) => {
                    this.surveyQuestions = this.mapQuestions(res.data)
                    Swal.fire({
                        text: _t("Questions updated successfully!"),
                        icon: "success",
                        duration: '1000'
                    })
                    window.location.reload();
                })
                .catch((err) => {
                    console.log(err)
                    Swal.fire({
                        text: err.response.data.message || 'Something went wrong',
                        icon: "error",
                        duration: '1000'
                    })
                });

        },
        mapQuestions(questions) {
            return questions.map(question => {
                const mappedQuestion = {
                    text: question.text || '',
                    type: question.type || 'open',
                    is_required: question.is_required,
                    answers: question.answers || [],
                    sort_order: question.sort_order,
                    id: question.id || null,
                    desktop_image_url: question.desktop_image_url || null,
                    mobile_image_url: question.mobile_image_url || null
                };

                if (mappedQuestion.type !== 'open' && mappedQuestion.type !== 'number') {
                    mappedQuestion.answers = mappedQuestion.answers.map(answer => {
                        return {
                            text: answer.text || '',
                            sort_order: answer.sort_order,
                            id: answer.id || null
                        };
                    });
                }
                return mappedQuestion;
            });
        },
        handleFileChange(event, size) {
            const field = `${size}_image`
            const previewUrl = field + '_preview';
            if(event.target.files && event.target.files.length > 0)
            {
                this.newQuestion[field] = event.target.files[0];
                this.newQuestion[previewUrl] = Url.createObjectURL(event.target.files[0]);
            }
            else
            {
                this.newQuestion[field] = false;
                this.newQuestion[previewUrl] = false;
            }

            this.$forceUpdate();

        }
    },

};
</script>

<style scoped>
/* Add your component styles here */
/**/
.mt-3 {
    margin-top: 0.75em;
}
img {
    max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/Questions.vue